import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./auth-guard.service";
import { LoginComponent } from "./login/login.component";
import { NeedPayComponent } from "./needpay/needpay.component";
import { PasswdChangeComponent } from "./passwd-change/passwd-change.component";
import { PasswdComponent } from "./passwd/passwd.component";
import { RegisterComponent } from "./register/register.component";
import { CargoInfoComponent } from "./cargo-info/cargo-info.component";
import { MobileAppLoginComponent } from "./mobile-app-login/mobile-app-login.component";

const appRoutes: Routes = [


    { path: 'needpay', component: NeedPayComponent },
    { path: 'login', component: LoginComponent },
    { path: 'register-info', component: RegisterComponent, canActivate: [AuthGuard], data: { editProfileMode: true, passwd: false, userRole: ['customer'] } },
    { path: 'register', component: RegisterComponent, data: { editProfileMode: false } },
    { path: 'reset-passwd', component: PasswdComponent },
    { path: 'change-passwd', component: PasswdChangeComponent, canActivate: [AuthGuard], data: { editProfileMode: true, passwd: true, userRole: ['customer', 'admin'] } },
    { path: 'app-login', component: MobileAppLoginComponent, canActivate: [AuthGuard], data: { userRole: ['admin', 'storeman', 'storage', 'customer'] } },
    { path: 'cargo-info', component: CargoInfoComponent, canActivate: [AuthGuard], data: { userRole: ['admin', 'storeman', 'storage', 'customer'] } },

]

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
    exports: [RouterModule]
})
export class AuthRoutingModule { };